import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  ConfigProvider,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Button,
} from "antd";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import DownloadTableButtons from "../../../components/DownloadTableButtons";

import { rightAction } from "../../../redux/actions";
import { apiConfig, labelConfig, staticConfig } from "../../configurations/configurations.config";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const columns = [
  {
    title: labelConfig.currencyName,
    dataIndex: "currencyName",
  },
  {
    title: labelConfig.currencyCode,
    dataIndex: "currencyCode",
  },

  {
    title: labelConfig.numericCode,
    dataIndex: "glAccountName",
  },

  {
    title: labelConfig.isoCode,
    dataIndex: "glAccountCode",
  },
];

const ManageCurrency = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [currencyList, setCurrencyList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  useEffect(() => {
    getCurrencyTemplate();
    BOM.HasPermission("UPDATE_CURRENCY") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getCurrencyTemplate = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(
      body,
      apiConfig.Currencies,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        } else {
          const objList = res;
          let tempArray = [];

          objList?.selectedCurrencyOptions?.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id,
              currencyName: element?.name ? element?.name : "-",
              currencyCode: element?.code ? element?.code : "-",
            });
          });

          setCurrencyList(tempArray);

          //keep the orginal data to use after gList is modified when change from autorise to disable
          setOriginalList(tempArray);

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          getCurrencyTemplate();
          setIsLoading(false);
        },
      }
    );
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, apiConfig.Currencies, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempArray = [];

          objList?.selectedCurrencyOptions?.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id,
              currencyName: element?.name ? element?.name : "-",
              currencyCode: element?.code ? element?.code : "-",
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  //DECLARED METHODS

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value.toLowerCase();

    if (!searchKey) {
      setCurrencyList(originalList);
      return;
    }
    const filterBySearch = originalList.filter((item) =>
      item?.currencyName?.toLowerCase().includes(searchKey)
    );
    setCurrencyList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-currency", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  return (
    <MainLayout isEnableRightSidebar={true} onAdd={handleOnCreate}>
      <TopContent
        pageTitle={labelConfig.manageCurrency}
        pageItems={staticConfig.manageCurrencyBreadcrumbItems}
      />

      <Card
        title={`${labelConfig.manageCurrency} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>
            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name..."
                style={{
                  width: 400,
                }}
              />
            </div>
            <DownloadTableButtons
              downloadData={currencyList}
              columns={columns}
              fileName={"Currency List"}
              onExportClick={getCsvListData}
            />
          </Row>
          <Table
            columns={columns}
            dataSource={currencyList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(ManageCurrency);
